import React, { useState, useEffect } from 'react';
import './Loaders.css';

const SubmissionLoader = ({
  step = '',
  isSuccess = false,
  onSuccess = null
}) => {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setShowSuccess(true);
      if (onSuccess) {
        setTimeout(() => {
          onSuccess();
        }, 2000);
      }
    }
  }, [isSuccess, onSuccess]);

  return (
    <div className="submission-loader-overlay">
      <div className="submission-loader-modal">
        {!showSuccess ? (
          <>
            {/* Loading State */}
            <div className="submission-spinner-container">
              <div className="loader-spinner"></div>
            </div>

            <h2 className="submission-title">Creating Your Product...</h2>

            {step && (
              <p className="submission-step">{step}</p>
            )}

            {/* Progress Steps */}
            <div className="submission-steps">
              <div className={`step-item ${step.includes('Converting') ? 'active' : step.includes('Uploading') || step.includes('Finalizing') ? 'completed' : ''}`}>
                <div className="step-dot"></div>
                <span>Converting images</span>
              </div>
              <div className={`step-item ${step.includes('Uploading') ? 'active' : step.includes('Finalizing') ? 'completed' : ''}`}>
                <div className="step-dot"></div>
                <span>Uploading to Shopify</span>
              </div>
              <div className={`step-item ${step.includes('Finalizing') ? 'active' : ''}`}>
                <div className="step-dot"></div>
                <span>Finalizing</span>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Success State */}
            <div className="loader-success-icon"></div>
            <h2 className="submission-title success">Product Created Successfully!</h2>
            <p className="submission-step">Your product has been listed</p>
          </>
        )}
      </div>
    </div>
  );
};

export default SubmissionLoader;
